export default {
  veiculos: null
}
